import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
//import * as Popper from "@popperjs/core"
import jQuery from "jquery";
//import DataTable from 'datatables.net-bs5';

// Editor Quill
//import 'quill/dist/quill.core.css'
//import 'quill/dist/quill.snow.css'

import "material-icons/iconfont/material-icons.css";

import "./assets/css/main.css";

createApp(App).use(store).use(router).use(jQuery).mount("#app");
